"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Renderables_1 = require("../Renderables");
var node_1 = require("../../support/node");
var Specification_1 = require("../../support/Specification");
/**
 * Implementation of the 'bold' markup element. A
 * b HTML element is created and the lto-bold class
 * is added to allow CSS modifications.
 *
 * @see {@link IRenderable}
 */
var Bold = /** @class */ (function () {
    function Bold(message) {
        this.spec = message;
    }
    /**
     * @inheritDoc
     */
    Bold.prototype.render = function (renderer, isNested) {
        var bold = node_1.default("b");
        new Specification_1.Specification(this.spec).initNode(bold, "lto-bold");
        bold.setAriaLabel(this.spec.ariaLabel);
        return bold.unwrap();
    };
    return Bold;
}());
exports.Bold = Bold;
Renderables_1.default.register("bold", Bold);
